var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvitationPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E76F2A",
    d: "M8.399.613l.072.035.06.042 1.968 1.63h2.842c.181 0 .34.103.418.262l.025.062.017.067.006.074v2.272l1.905 1.577.051.052.027.033.018.03.027.05c.011.027.02.054.027.084l.009.048.003.057v8.417c.001.125-.047.244-.135.333-.052.053-.116.092-.189.115l-.076.018-.066.005H1.048c-.203 0-.379-.131-.442-.325l-.017-.066-.006-.075V6.99c0-.029.002-.058.008-.088l.012-.047.023-.061.027-.05.023-.034L.7 6.68l.053-.052L2.65 5.058V2.785c0-.18.104-.34.263-.417l.062-.026.067-.016.074-.007H5.96L7.937.69c.13-.107.307-.134.462-.076zm6.543 7.302l-1.234.916c-.023.03-.05.057-.082.082l-.052.036-.044.02-5.023 3.745c-.12.09-.274.115-.42.07l-.071-.03-.066-.04-4.996-3.726c-.036-.014-.07-.032-.103-.056l-.049-.04-.031-.036-1.257-.94v7.028l13.428-.004V7.915zM12.876 3.25H3.583v5.045l4.646 3.464 4.647-3.464V3.25zM8.592 5.404l.103.103V6.72h1.213l.103.103v.726l-.103.103H8.695v1.212l-.103.103h-.725l-.103-.103V7.651H6.55l-.103-.102v-.726l.103-.103h1.213V5.507l.103-.103h.725zm-5.941.866l-.848.702.848.633V6.27zm11.156 0v1.332l.849-.633-.85-.7zM8.229 1.647l-.805.671h1.61l-.805-.67z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvitationPending);
export default __webpack_public_path__ + "static/media/invitation-pending.607f3fa7ee8896ea8f5cd1b9bddb1de9.svg";
export { ForwardRef as ReactComponent };